import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";

import { useAIChat } from "@/Chat/ChatSidebar/AIChatContext";
import { RobotoIconButton } from "@/shared/components/RobotoIconButton";
import { RobotoTooltip } from "@/shared/components/RobotoTooltip";

import styles from "./ChatSidebarControls.module.css";

interface ChatSidebarControlsProps {
  onClose: () => void;
}

const ChatSidebarControls = ({ onClose }: ChatSidebarControlsProps) => {
  const {
    isFullscreen,
    handleNewChat,
    handleToggleFullscreen,
    handleToggleHistory,
    showHistory,
  } = useAIChat();

  return (
    <header className={styles.header}>
      <div className={styles.titleContainer}>
        {/* Title removed - will be added back if needed */}
      </div>
      <div className={styles.navItems}>
        <RobotoTooltip
          title={showHistory ? "Hide Chat History" : "List Chat History"}
        >
          <span>
            <RobotoIconButton
              onClick={handleToggleHistory}
              eventName={"ChatHistoryToggled"}
              size="small"
            >
              {showHistory ? (
                <LibraryBooksIcon className={styles.activeIconButton} />
              ) : (
                <LibraryBooksIcon className={styles.iconButton} />
              )}
            </RobotoIconButton>
          </span>
        </RobotoTooltip>
        <RobotoTooltip title={"New Chat"}>
          <span>
            <RobotoIconButton
              onClick={handleNewChat}
              eventName={"NewChatClicked"}
              size="small"
            >
              <AddIcon className={styles.iconButton} />
            </RobotoIconButton>
          </span>
        </RobotoTooltip>
        <RobotoTooltip title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}>
          <span>
            <RobotoIconButton
              onClick={handleToggleFullscreen}
              eventName={"ChatFullscreenToggled"}
              size="small"
            >
              {isFullscreen ? (
                <FullscreenExitIcon className={styles.iconButton} />
              ) : (
                <FullscreenIcon className={styles.iconButton} />
              )}
            </RobotoIconButton>
          </span>
        </RobotoTooltip>
        <RobotoTooltip title={"Close"}>
          <span>
            <RobotoIconButton
              onClick={onClose}
              eventName={"CloseChatWindowClose"}
              size="small"
            >
              <CloseIcon className={styles.iconButton} />
            </RobotoIconButton>
          </span>
        </RobotoTooltip>
      </div>
    </header>
  );
};

export { ChatSidebarControls };
